import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


/* 
sudo npm install -g @angular/cli@15.2.9
ng new project_name
npm install pdfjs-dist,
npm install chart.js
npm install socket.io-client
ng add @angular/material

npm install chart.js --legacy-peer-deps
yarn add @toast-ui/editor @toast-ui/editor-plugin-code-syntax-highlight highlight.js

npm install bootstrap
ng generate component element
ng generate component element/detail
ng generate component back-office/virtualcampus/vca-advertisment
ng generate module modules/api-service

ng serve --host 192.168.1.200 --disable-host-check --port 8002
pm2 start "ng serve --host 192.168.1.200 --disable-host-check --port 8002" --name BACK-OFFICE
sudo pkill -f :82
sudo kill -9 $(sudo lsof -t -i:82)

git push origin master --force
*/

/* 
KETCHER
git clone https://github.com/epam/ketcher.git
cd ketcher/


Allow Explicit Carbon and Hydrogen
Open packages/ketcher-core/src/application/render/restruct/reatom.ts
Initilize inside  class ReAtom extends ReObject 
showExplicitCH = false;
Change this.showLabel = isLabelVisible(restruct, render.options, this);
To 
this.showLabel = this.showExplicitCH || isLabelVisible(restruct, render.options, this);

Add After
let text = getLabelText(atom.a, atomId, sgroup, options) || 'R#';
This 
///Added
if (atom.showExplicitCH && atom.a.label === 'C') {
  const hCount = Math.floor(atom.a.implicitH);
  text = hCount === 0 ? 'C' : hCount === 1? 'CH': `CH${hCount}`;
}

Open packages/ketcher-react/src/script/ui/views/components/ContextMenu/menuItems/SelectionMenuItems.tsx
and Open packages/ketcher-react/src/script/ui/views/components/ContextMenu/menuItems/AtomMenuItems.tsx
Before highlightBondWithColor in Selection an highlightAtomWithColor Atomfiles
add 
const handleToggleExplicitCH = (showExplicitCH:boolean) => {
    if (!editor) return;

    const selectedAtoms = props.propsFromTrigger?.atomIds || [];

    selectedAtoms.forEach((atomId) => {
      const reAtom = editor.render.ctab.atoms.get(atomId);

      if (reAtom && reAtom.a.label === 'C') {
        reAtom.showExplicitCH = showExplicitCH;
      }
    });

    editor.render.update(true);
  };
  And Add before Edit selected bonds for Selection Menu case 
  editMenu for Atom Menu
<Item
    {...props}
    data-testid="Show explicit C & H-option"
    onClick={() => {handleToggleExplicitCH(true);}}
  >
    Show Explicit C & H
  </Item>
  <Item
    {...props}
    data-testid="Hide explicit C & H-option"
    onClick={() => {handleToggleExplicitCH(false);}}
  >
    Hide Explicit C & H
  </Item>


>npm install ajv ajv-keywords --legacy-peer-deps
>npm run build
>npx serve -s example/build -l 3000

Copie content of example/build to assets/chemistry-ketcher
 */
